<script>
import InviteMixin from '@/components/dialogs/mixins/InviteMixin'
import notifications from '@/libs/notifications'
export default {
  methods: {
    submit () {
      if (!this.$refs.inviteUserForm.validate()) return
      this.invitingUser = true
      const companyId = this.$route.params.companyid
      this.$store.dispatch('inviteAdministrator', { companyId, users: this.arrayUsers })
        .then(response => {
          this.invitingUser = false
          notifications.success('¡Listo! Se enviaron las invitaciones')
          this.closeInvite()
        })
    }
  },
  mixins: [InviteMixin]
}
</script>
